import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import SEOHead from "@/components/SEOHead";
import JsonLd from "@/components/JsonLd";
import { SITE_URL, SITE_NAME } from "@/lib/constants";
import { homeSeo } from "@/lib/seoCopy";

const ArbitralisSection = lazy(() => import("@/components/ArbitralisSection"));

const FeaturedCourses = lazy(() => import("@/components/FeaturedCourses"));
const MarqueeTicker = lazy(() => import("@/components/MarqueeTicker"));
const LiveEventSection = lazy(() => import("@/components/LiveEventSection"));
const InstructorsSection = lazy(() => import("@/components/InstructorsSection"));
const PersonasSection = lazy(() => import("@/components/PersonasSection"));

const MaterialsSection = lazy(() => import("@/components/MaterialsSection"));
const GrandesJuristasSection = lazy(() => import("@/components/GrandesJuristasSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const CTASection = lazy(() => import("@/components/CTASection"));
const Footer = lazy(() => import("@/components/Footer"));

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  name: SITE_NAME,
  alternateName: "Emera Edu",
  url: SITE_URL,
  logo: `${SITE_URL}/logo-symbol.png`,
  description:
    "Escola da Arbitralis SA. Cursos online de arbitragem, IA no Direito e ECA Digital para advogados, com professores que atuam em casos reais.",
  foundingDate: "2025",
  areaServed: {
    "@type": "Country",
    name: "Brazil",
  },
  sameAs: [
    "https://www.linkedin.com/company/emeraedu",
    "https://www.instagram.com/emeraedu",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    availableLanguage: "Portuguese",
    url: `${SITE_URL}/#contato`,
  },
};

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <SEOHead
        title={homeSeo.title}
        description={homeSeo.description}
        url={SITE_URL}
        keywords={[
          "inovação jurídica",
          "advocacia 4.0",
          "legal design",
          "legaltech",
          "curso direito e tecnologia",
          "escola de direito inovação",
        ]}
      />
      <JsonLd data={organizationJsonLd} />
      <Navbar />
      <HeroSection />
      <Suspense fallback={<div className="min-h-[40vh]" aria-hidden />}>

        <ArbitralisSection />
        <FeaturedCourses />
        <PersonasSection />
        <MarqueeTicker />
        <LiveEventSection />
        <InstructorsSection />
        
        
        <MaterialsSection />
        <GrandesJuristasSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
